import React from 'react';
import styles from '../css/index.module.scss';
import InputsBlock from './InputsBlock';
import MyInput from '../../../components/MyInput';
import DropdownInput from '../../../components/DropdownInput';
import useSinglePartnerSettings from "../../../hooks/UseSinglePartnerSettings";

function Settings({savePartner}) {
  const { values, setters, errors } = useSinglePartnerSettings({ savePartner });

  return (
    <div className={styles.singlePartnerInfo}>
      <InputsBlock title="Общие настройки">
        <DropdownInput
          wrapperClassName={styles.input}
          value={values.isSmsEnabled}
          onChange={setters.isSmsEnabled}
          error={errors.isSmsEnabled}
          data={[{ value: 'active', label: 'Включено' }, { value: 'nonActive', label: 'Выключено' }]}
          labelTextTop="Смс информирование"
          placeholder="Выберите статус"
        />
        <MyInput
          wrapperClassName={styles.input}
          value={values.smsSenderName}
          onChange={setters.smsSenderName}
          error={errors.smsSenderName}
          labelTextTop="Имя отправителя"
          withLeftIcon={false}
        />
      </InputsBlock>
    </div>
  );
}

export default Settings;
